var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"32.0003","cy":"32.0032","r":"23.2698","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M20.3202 33.2902L27.213 40.183C27.667 40.183 38.664 28.9212 44.1057 23.2903","stroke":"currentColor","strokeLinecap":"round","key":1})]);
}

SVGIcon.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
